import type { ReactNode } from 'react'

// Checklisten-Zeile: bei Typ CHECK ist die ganze Zeile ein <label> (komplett antippbar), min. 64 px hoch.
export function ChecklistZeile({ typ, className = '', children }: { typ: string; className?: string; children: ReactNode }) {
  if (typ === 'CHECK') {
    return <label className={`block checklist-zeile min-h-[64px] cursor-pointer select-none active:bg-dark-bg-tertiary ${className}`}>{children}</label>
  }
  return <div className={`checklist-zeile min-h-[64px] ${className}`}>{children}</div>
}
